/**
 * 系统管理  角色管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>


    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="queryParams" class="user-search">

      <el-form-item label="搜索：">
        <el-input size="small" v-model="queryParams.query.roleName" placeholder="输入角色名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>


    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60">
      </el-table-column>
      <el-table-column prop="roleName" label="角色名称" >
      </el-table-column>
      <el-table-column align="center" label="操作" width="220">
        <template slot-scope="scope">

          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <el-button
              size="mini"
              icon="el-icon-edit-outline"
              @click="handleEdit(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            placement="top"
            v-show="scope.row.systemFlag != 1"
          >
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="deleteUser(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            content="菜单权限"
            placement="top"
          >
            <el-button
              size="mini"
              type="success"
              icon="el-icon-menu"
              @click="menuAccess(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>


<!--          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
          <el-button size="mini" type="success" @click="menuAccess(scope.$index, scope.row)">菜单权限</el-button>-->
        </template>
      </el-table-column>
    </el-table>


    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>


    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormShow" width="30%" :close-on-click-modal="false" @click='closeDialog("edit")'>
      <el-form label-width="120px" :model="form" ref="form" :rules="rules">
        <el-form-item label="角色名称" prop="roleName">
          <el-input size="small" v-model="form.roleName" auto-complete="off" placeholder="请输入角色名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('form')">保存</el-button>
      </div>
    </el-dialog>


    <!-- 菜单权限 -->
    <el-dialog title="菜单权限" :visible.sync="menuAccessshow" width="30%" :close-on-click-modal="false" @click='closeDialog("perm")'>
      <el-tree ref="tree" default-expand-all :data="RoleRight" :props="RoleRightProps" :default-checked-keys="checkmenu" node-key="resSeqId" show-checkbox>
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("perm")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="menuPermSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  roleList,
  createRole,
  editRole,
  destroyRole,
  getAllRes,    // 获取全部菜单权限
  getResList,   // 获取指定角色 菜单权限
  addFillRes   // 给角色 新增菜单权限
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userdata')),   // 用户信息
      loading: false, //是显示加载
      editFormShow: false, //控制编辑页面显示与隐藏
      menuAccessshow: false, //控制数据权限显示与隐藏
      title: '添加',
      form: {

      },
      // rules 表单验证
      rules: {
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ]
      },
      queryParams: {
        currentPage: 1,
        pageSize: 10,
        query: {

        }
      },
      listData: [], //用户数据
      // 数据权限
      RoleRight: [],
      RoleRightProps: {
        children: 'children',
        label: 'resName'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  watch: {},

  /**
   * 创建完毕
   */

  created() {
    this.initData();
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    initData() {
      this.getdata()
      this.getAllRes()    // 获取全部 菜单权限
    },
    getAllRes() {
      getAllRes().then(res => {
        if (res.code == 200) {
          this.RoleRight = res.data;
        }
      })
    },
    // 获取角色列表
    getdata() {
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      roleList(JSON.stringify(this.queryParams)).then(res => {
        this.loading = false
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.data.list
          // 分页赋值
          this.pageparm = res.data.pageParam
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('加载失败，请稍后再试！')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.currentPage = parm.currentPage
      this.queryParams.pageSize = parm.pageSize
      this.getdata()
    },
    // 搜索事件
    search() {
      this.getdata()
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormShow = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.form = JSON.parse(JSON.stringify(row));
      } else {
        this.title = '添加'
        this.form = {};
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if (this.form.roleSeqId) {

            // 修改
            editRole(JSON.stringify(this.form)).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '修改成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('修改失败，请稍后再试！')
            })
          } else {

            // 新增
            createRole(JSON.stringify(this.form)).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }

        } else {
          return false
        }
      })
    },
    // 删除角色
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          destroyRole(JSON.stringify([row.roleSeqId])).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功！'
              })
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('删除失败，请稍后再试！')
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 数据权限
    menuAccess: function(index, row) {
      this.menuAccessshow = true
      this.saveroleId = row.roleSeqId
      getResList(row.roleSeqId).then(res => {
        if (res.code == 200) {
          // 处理 菜单权限回显
          this.changemenu(res.data)
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
    },
    // 选中菜单
    changemenu(arr) {
      let change = []
      this.RoleRight.forEach(res => {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].resSeqId ==  res.resSeqId) {
            change.push(arr[i].resSeqId)
          }
        }
      })
      if (change.length > 0) {
        this.$refs.tree.setCheckedKeys(change, true)
      } else {
        this.$refs.tree.setCheckedKeys(change, false)
      }
    },
    // 菜单权限-保存
    menuPermSave() {
      let parm = {
        roleSeqId: this.saveroleId,
        resSeqIds: []
      }
      let node = this.$refs.tree.getCheckedNodes()
      let resSeqIds = []
      if (node.length != 0) {
        for (let i = 0; i < node.length; i++) {
          resSeqIds.push(node[i].resSeqId)
        }
        parm.resSeqIds = resSeqIds
      }
      addFillRes(parm).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '菜单权限保存成功'
          })
          this.menuAccessshow = false
          this.getdata()
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('菜单权限保存失败，请稍后再试！')
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.form = {}
        this.editFormShow = false
      } else if (dialog == 'perm') {
        this.checkmenu = [];
        this.menuAccessshow = false
      }
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/system/Role.vue